import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from './translate.service';

/** Available label variations. */
type LabelVariation = 'capFirstLetter' | 'placeholder' | 'placeholderLowerCase' | 'textWithPlaceholder' | 'lowerCase' | 'upperCase' |
  'plural' | 'pluralLowerCase' | 'pluralUpperCase' | 'pluralCapFirstLetter';


/**
 * Translate pipe.
 */
@Pipe({
  name: 'translate'
})
export class TranslatePipe implements PipeTransform {

  /** Constructor. */
  constructor(
    private translateService: TranslateService
  ) { }

  /**
   * Translate label.
   *
   * @param translateString Input string.
   * @param [variation] Label helper variation.
   */
  transform(translateString: string, variation?: LabelVariation): any {
    switch (variation) {
      case 'capFirstLetter':
        return this.translateService.getCapFirstLetter(translateString);
      case 'placeholder':
        return this.translateService.getPlaceholder(translateString);
      case 'placeholderLowerCase':
        return this.translateService.getPlaceholderLowerCase(translateString);
      case 'textWithPlaceholder':
        return this.translateService.getTextWithPlaceholder(translateString);
      case 'lowerCase':
        return this.translateService.getLowerCase(translateString);
      case 'upperCase':
        return this.translateService.getUpperCase(translateString);
      case 'plural':
        return this.translateService.getPlural(translateString);
      case 'pluralLowerCase':
        return this.translateService.getPluralLowerCase(translateString);
      case 'pluralUpperCase':
        return this.translateService.getPluralUpperCase(translateString);
      case 'pluralCapFirstLetter':
        return this.translateService.getPluralCapFirstLetter(translateString);
      default:
        return this.translateService.get(translateString);
    }
  }

}
